import { HTMLFontFace } from "jspdf"
import styled from "styled-components"
import InterBold from "../../fonts/Inter/Inter-Bold.ttf"
import KarlaMedium from "../../fonts/Karla/Karla-Medium.ttf"

export const REPORT_FONT_FACES: HTMLFontFace[] = [
  {
    family: "Karla",
    src: [{ url: KarlaMedium, format: "truetype" }],
    style: "normal",
    weight: "500",
  },
  {
    family: "Inter",
    src: [{ url: InterBold, format: "truetype" }],
    style: "normal",
    weight: "600",
  },
]

export const ReportText = styled.span`
  font-size: 10px;
  font-family: Karla, sans-serif;
  font-weight: 500;
  line-height: 1;
  color: #616161;
`

export const ReportTitle = styled.span`
  font-size: 18px;
  font-family: Inter, sans-serif;
  font-weight: 600;
  line-height: 1;
  color: #616161;
`

export const ReportSubtitle = styled.span`
  font-size: 14px;
  font-family: Inter, sans-serif;
  font-weight: 600;
  line-height: 1;
  color: #616161;
`
